import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import './i18n'
// Compile only the selected distribution entry. Production stays on the current
// site until the reviewed marketing artifact and new screencast are approved.
const App = lazy(() => import.meta.env.VITE_MARKETING_ONLY === 'true'
  ? import('./MarketingApp.jsx')
  : import('./App.jsx'));


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <Suspense fallback={null}><App /></Suspense>
    </HelmetProvider>
  </StrictMode>,
)
